// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BD4x","colBig":"styles_colBig__2OJy6","colSmall":"styles_colSmall__3nGpJ","shopifyNameWrapper":"styles_shopifyNameWrapper__2p981"};